import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";

const servicesOptions = [
  { value: "bulk_water_service", label: "Bulk water service" },
  { value: "retail_water_service", label: "Retail water service" },
  { value: "bulk_wastewater_service", label: "Bulk wastewater service" },
  { value: "retail_wastewater_service", label: "Retail wastewater service" },
  { value: "drainage_stormwater_service", label: "Drainage / stormwater service" },
];

const ServicesSelect = ({ onServicesChange, selectedServicesOptions }) => (
  <Select
    classNamePrefix="Select"
    classNames={{ container: () => "Select__container" }}
    onChange={e => onServicesChange(e)}
    options={servicesOptions}
    placeholder="Services provided..."
    value={selectedServicesOptions}
    isMulti
    isSearchable={false}
  />
);

ServicesSelect.propTypes = {
  onServicesChange: PropTypes.func.isRequired,
  selectedServicesOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  }))
};

export default ServicesSelect;
